import React from 'react';
import { useSelector, useDispatch } from 'react-redux';

function ActiveSelect({ id, label }) {
  const dispatch = useDispatch();
  const { values: details, editing, saving } = useSelector(store => store.details);

  function handleChange({ target }) {
    dispatch({
      type: 'EDIT_DETAILS',
      id: 'is_active',
      value: target.value === 'Active',
      valid: true,
    });
  }

  const value = details[id];

  return (
    <div className="text-capitalize font-large mb-2">
      <label htmlFor={id} className="form-label fw-bold">
        {label}
      </label>
      <select
        className="form-control"
        type="select"
        id={id}
        value={value ? 'Active' : 'Inactive'}
        onChange={(e) => handleChange(e)}
        disabled={!editing || saving}
        size="sm"
      >
        <option>Active</option>
        <option>Inactive</option>
      </select>
    </div>
  );
}

export default ActiveSelect;
